import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	application: [],
	loading: false,
	loadingSubmit: false
};

export default function reviewAndSubmissionPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_APPLICATION_BY_APPLICATION_ID_REQUEST:
		case ActionTypes.GET_APPLICATION_BY_APPLICATION_ID_ERROR:
		case ActionTypes.GET_APPLICATION_BY_APPLICATION_ID_SUCCESS:
		case ActionTypes.SUBMIT_APPLICATION_REQUEST:
		case ActionTypes.SUBMIT_APPLICATION_ERROR:
		case ActionTypes.SUBMIT_APPLICATION_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_APPLICATION_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_APPLICATION_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
